import { Box, Typography } from "../../../../Components";
import { Form } from "react-bootstrap";

const Surgical = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  const options = [
    {
      id: 1,
      label: "No",
    },
    {
      id: 2,
      label: "Yes",
    },
  ];
  return (
    <div>
      {" "}
      <Typography fontSize="1rem" fontWeight="400" color="#E30020">
        MEDICAL HISTORY
      </Typography>
      <Typography fontSize="1.25rem" fontWeight="500" className="my-3">
        Surgical History
      </Typography>
      {options?.map((option, idx) => (
        <>
          <Box
            className="p-3 my-3 cursor-pointer option-wrapper"
            onClick={() => {
              setFieldValue("surgical", option?.id);
            }}
            height="100%"
            width="100%"
            borderRadius="0.5rem"
            background={values?.surgical === option?.id && "#E30020"}
            border={values?.surgical === option?.id && "1px solid #E30020"}
          >
            <Typography
              fontSize=".9rem"
              fontWeight={values?.surgical === option?.id && "500"}
              className="heading"
              color={values?.surgical === option?.id && "white"}
            >
              {option?.label}
            </Typography>
          </Box>
          {values?.surgical === 2 && option?.id === 2 && (
            <>
              <Form.Control
                type="text"
                backgroundColor="#EBEBFF"
                name="surgicalInput"
                placeholder={
                  "e.g. cardiac stenting in 2019, appendectomy in 2003"
                }
                className="w-100 fs-6"
                value={values?.surgicalInput}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.surgicalInput && !!errors.surgicalInput}
                size="lg"
                autoFocus
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.surgicalInput}
              </Form.Control.Feedback>
            </>
          )}
        </>
      ))}
    </div>
  );
};

export default Surgical;
